// components/StatusFilterHeader.tsx
import React from 'react';
import { Link } from 'react-router-dom';

interface FilterHeaderProps {
    title: string;
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    selectedSort: string;
    setSelectedSort: (sort: string) => void;
    selectedYear: string;
    setSelectedYear: (year: string) => void;
    selectedMonth: string;
    setSelectedMonth: (month: string) => void;
}

const StatusFilterHeaderWithYearMonth: React.FC<FilterHeaderProps> = ({
    title,
    selectedStatus,
    setSelectedStatus,
    selectedSort,
    setSelectedSort,
    selectedYear,
    setSelectedYear,
    selectedMonth,
    setSelectedMonth
}) => {
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => `${currentYear - i}`);

    return (
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>{title}</h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* Year Filter */}
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedYear ? `Year: ${selectedYear}` : "Select Year"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {years.map((year) => (
                            <li key={year}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedYear(year)}
                                    className="dropdown-item rounded-1"
                                >
                                    {year}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Month Filter */}
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedMonth ? `Month: ${selectedMonth}` : "Select Month"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {months.map((month) => (
                            <li key={month}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedMonth(month)}
                                    className="dropdown-item rounded-1"
                                >
                                    {month}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Status Filter */}
                {/* <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedStatus ? selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1) : "Select Status"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {["All", "active", "inactive"].map((status) => (
                            <li key={status}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedStatus(status)}
                                    className="dropdown-item rounded-1"
                                >
                                    {status.charAt(0).toUpperCase() + status.slice(1)}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div> */}

                {/* Sort Filter */}
                <div className="dropdown">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedSort ? `Sort By : ${selectedSort}` : "Sort By : Last 7 Days"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {["Recently Added", "Ascending", "Descending", "Last Month", "Last 7 Days"].map((sort) => (
                            <li key={sort}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedSort(sort)}
                                    className="dropdown-item rounded-1"
                                >
                                    {sort}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>



            </div>
        </div>
    );
};

export default StatusFilterHeaderWithYearMonth;
